

export class VehicleTypeSelectOutputWithoutStatus implements IVehicleTypeSelectOutputWithoutStatus {
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id!: number;
    /** The vehicle type name with 255 character limit */
    vehicle_type_name!: string;

    constructor(data?: IVehicleTypeSelectOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_type_id = _data["vehicle_type_id"];
            this.vehicle_type_name = _data["vehicle_type_name"];
        }
    }

    static fromJS(data: any): VehicleTypeSelectOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeSelectOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_type_id"] = this.vehicle_type_id;
        data["vehicle_type_name"] = this.vehicle_type_name;
        return data; 
    }
}

export interface IVehicleTypeSelectOutputWithoutStatus {
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id: number;
    /** The vehicle type name with 255 character limit */
    vehicle_type_name: string;
}

